import type { IRoute } from "@/common/types/router"
import type { RouteRecordRaw } from "vue-router"
import ErrorView from "@/common/views/ErrorView.vue"
import ForbiddenView from "@/common/views/ForbiddenView.vue"
import UnauthorizedView from "@/common/views/UnauthorizedView.vue"
import NotFoundView from "@/common/views/NotFoundView.vue"

type Names = {
    error
    forbidden
    unauthorized
    notFound
}

export const baseRoute: IRoute<Names> = {
    error: {
        path: "/error",
        name: "error"
    },
    forbidden: {
        path: "/forbidden",
        name: "forbidden"
    },
    unauthorized: {
        path: "/unauthorized",
        name: "unauthorized"
    },
    notFound: {
        path: "/:pathMatch(.*)*",
        name: "notFound"
    }
}

export const baseRoutes: RouteRecordRaw[] = [
    {
        ...baseRoute.error,
        component: ErrorView
    },
    {
        ...baseRoute.forbidden,
        component: ForbiddenView
    },
    {
        ...baseRoute.unauthorized,
        component: UnauthorizedView
    },
    {
        ...baseRoute.notFound,
        component: NotFoundView
    }
]
